/* ===== Daily Bear global store lock ===== */
(function () {
  const storeOpen = document.body && document.body.dataset.storeOpen === 'true';
  if (storeOpen) return;

  function tr(key, fallback) {
    return window.DailyBearI18n ? window.DailyBearI18n.t(key) : fallback;
  }

  document.addEventListener('submit', function (event) {
    const form = event.target;
    if (!form || !form.matches || !form.matches('form[action*="/cart/add"], form[action*="/cart"]')) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    alert(tr('ordering_blocked', 'Daily Bear opent binnenkort. Je kunt de smaken al bekijken, maar nog niet bestellen.'));
  }, true);

  document.addEventListener('click', function (event) {
    const blocked = event.target.closest('[data-db-cart-checkout], button[name="checkout"], button[name="add"], .db-atc-button');
    if (!blocked) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    alert(tr('ordering_blocked', 'Daily Bear opent binnenkort. Je kunt de smaken al bekijken, maar nog niet bestellen.'));
  }, true);
})();

document.addEventListener('DOMContentLoaded', () => {
  const openBtn = document.querySelector('[data-mobile-menu-open]');
  const closeBtn = document.querySelector('[data-mobile-menu-close]');
  const drawer = document.querySelector('[data-mobile-drawer]');
  const setDrawer = (open) => {
    if (!drawer || !openBtn) return;
    drawer.classList.toggle('is-open', open);
    document.body.classList.toggle('no-scroll', open);
    openBtn.setAttribute('aria-expanded', open ? 'true' : 'false');
  };
  openBtn?.addEventListener('click', () => setDrawer(true));
  closeBtn?.addEventListener('click', () => setDrawer(false));
  drawer?.querySelectorAll('a').forEach((link) => link.addEventListener('click', () => setDrawer(false)));

  document.querySelectorAll('[data-gallery]').forEach((gallery) => {
    const main = gallery.querySelector('[data-gallery-main]');
    const thumbs = gallery.querySelectorAll('[data-gallery-thumb]');
    thumbs.forEach((thumb) => {
      thumb.addEventListener('click', () => {
        const src = thumb.getAttribute('data-src');
        const alt = thumb.getAttribute('data-alt') || '';
        if (main && src) {
          main.src = src;
          main.alt = alt;
        }
        thumbs.forEach((item) => item.classList.remove('is-active'));
        thumb.classList.add('is-active');
      });
    });
  });

  document.querySelectorAll('[data-tabs]').forEach((tabs) => {
    const buttons = tabs.querySelectorAll('[data-tab-button]');
    const panels = tabs.querySelectorAll('[data-tab-panel]');
    buttons.forEach((button) => {
      button.addEventListener('click', () => {
        const id = button.getAttribute('data-tab-button');
        buttons.forEach((b) => b.classList.remove('is-active'));
        panels.forEach((p) => p.classList.remove('is-active'));
        button.classList.add('is-active');
        tabs.querySelector(`[data-tab-panel="${id}"]`)?.classList.add('is-active');
      });
    });
  });
});
/* ===== Daily Bear fixed interactions ===== */
(function () {
  const root = window.Shopify && Shopify.routes ? Shopify.routes.root : '/';

  function pad(n) {
    return String(n).padStart(2, '0');
  }

  function formatDailyBearMoney(cents) {
    return new Intl.NumberFormat((document.documentElement.lang || 'nl').toLowerCase().startsWith('en') ? 'en-BE' : 'nl-BE', {
      style: 'currency',
      currency: 'EUR'
    }).format((cents || 0) / 100);
  }

  function updateCountdown(el) {
    const target = new Date(el.getAttribute('data-countdown')).getTime();
    if (Number.isNaN(target)) return;

    const days = el.querySelector('[data-days]');
    const hours = el.querySelector('[data-hours]');
    const minutes = el.querySelector('[data-minutes]');
    const seconds = el.querySelector('[data-seconds]');

    function tick() {
      const diff = Math.max(0, target - Date.now());
      const d = Math.floor(diff / 86400000);
      const h = Math.floor((diff % 86400000) / 3600000);
      const m = Math.floor((diff % 3600000) / 60000);
      const s = Math.floor((diff % 60000) / 1000);

      if (days) days.textContent = pad(d);
      if (hours) hours.textContent = pad(h);
      if (minutes) minutes.textContent = pad(m);
      if (seconds) seconds.textContent = pad(s);
    }

    tick();
    setInterval(tick, 1000);
  }

  function updateCartDiscount(cart) {
    const summary = document.querySelector('[data-cart-summary]');
    if (!summary) return;

    let row = summary.querySelector('[data-cart-discount-row]');
    const totalRow = summary.querySelector('[data-cart-total-row]');

    if (cart.total_discount > 0) {
      if (!row) {
        row = document.createElement('div');
        row.className = 'cart-summary__row cart-summary__row--discount';
        row.setAttribute('data-cart-discount-row', '');
        row.innerHTML = '<span>Korting</span><span data-cart-discount></span>';
        summary.insertBefore(row, totalRow);
      }

      row.classList.remove('is-hidden');
      const discountAmount = row.querySelector('[data-cart-discount]');
      if (discountAmount) {
        discountAmount.textContent = '-' + formatDailyBearMoney(cart.total_discount);
      }
    } else if (row) {
      row.classList.add('is-hidden');
    }
  }

  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('[data-countdown]').forEach(updateCountdown);

    const popup = document.querySelector('[data-launch-popup]');
    if (popup && !sessionStorage.getItem('dailyBearLaunchPopupClosed')) {
      setTimeout(function () {
        popup.hidden = false;
        document.body.classList.add('no-scroll');
      }, 450);
    }

    function closePopup() {
      if (!popup) return;
      popup.hidden = true;
      document.body.classList.remove('no-scroll');
      sessionStorage.setItem('dailyBearLaunchPopupClosed', '1');
    }

    if (popup) {
      popup.querySelectorAll('[data-launch-popup-close]').forEach(function (btn) {
        btn.addEventListener('click', closePopup);
      });
    }

    const modal = document.createElement('div');
    modal.className = 'image-modal';
    modal.innerHTML =
      '<div class="image-modal__overlay" data-image-modal-close></div>' +
      '<div class="image-modal__panel">' +
      '<button class="image-modal__close" type="button" aria-label="Sluiten" data-image-modal-close>×</button>' +
      '<img alt="Vergrote afbeelding">' +
      '</div>';

    document.body.appendChild(modal);

    const modalImg = modal.querySelector('img');

    function closeModal() {
      modal.classList.remove('is-open');
      document.body.classList.remove('no-scroll');
    }

    document.querySelectorAll('[data-image-modal-trigger]').forEach(function (trigger) {
      trigger.addEventListener('click', function () {
        const img = trigger.querySelector('img');
        if (!img || !modalImg) return;

        modalImg.src = img.currentSrc || img.src;
        modalImg.alt = img.alt || '';
        modal.classList.add('is-open');
        document.body.classList.add('no-scroll');
      });
    });

    modal.querySelectorAll('[data-image-modal-close]').forEach(function (btn) {
      btn.addEventListener('click', closeModal);
    });

    document.addEventListener('keyup', function (event) {
      if (event.key === 'Escape') {
        closeModal();
        closePopup();
      }
    });

    document.querySelectorAll('[data-bundles]').forEach(function (box) {
      const form = box.closest('form') || document.querySelector('form[action*="/cart/add"]');
      if (!form || form.dataset.dailyBearBundleReady === 'true') return;

      form.dataset.dailyBearBundleReady = 'true';

      let qtyInput = form.querySelector('[data-bundle-quantity]') || form.querySelector('input[name="quantity"]');

      if (!qtyInput) {
        qtyInput = document.createElement('input');
        qtyInput.type = 'hidden';
        qtyInput.name = 'quantity';
        qtyInput.value = '1';
        qtyInput.setAttribute('data-bundle-quantity', '');
        form.appendChild(qtyInput);
      }

      let selectedButton =
        box.querySelector('[data-bundle-qty].is-selected') ||
        box.querySelector('[data-bundle-qty]');

      let selectedDiscount = '';

      if (selectedButton) {
        box.querySelectorAll('[data-bundle-qty]').forEach(function (btn) {
          btn.classList.remove('is-selected');
        });

        selectedButton.classList.add('is-selected');
        qtyInput.value = selectedButton.getAttribute('data-bundle-qty') || '1';
        selectedDiscount = selectedButton.getAttribute('data-bundle-discount') || '';
      }

      box.querySelectorAll('[data-bundle-qty]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          box.querySelectorAll('[data-bundle-qty]').forEach(function (item) {
            item.classList.remove('is-selected');
          });

          btn.classList.add('is-selected');
          qtyInput.value = btn.getAttribute('data-bundle-qty') || '1';
          selectedDiscount = btn.getAttribute('data-bundle-discount') || '';
        });
      });

      form.addEventListener('submit', async function (event) {
        event.preventDefault();

        const formData = new FormData(form);

        try {
          await fetch(root + 'cart/add.js', {
            method: 'POST',
            body: formData
          });

          if (selectedDiscount) {
            sessionStorage.setItem('db_pending_discount', selectedDiscount);
document.dispatchEvent(new CustomEvent('db:open-cart-drawer'));
          } else {
           document.dispatchEvent(new CustomEvent('db:open-cart-drawer'));
          }
        } catch (error) {
          console.error(error);
          form.submit();
        }
      });
    });
  });

  document.addEventListener('click', async function (event) {
    const minus = event.target.closest('[data-qty-minus]');
    const plus = event.target.closest('[data-qty-plus]');

    if (!minus && !plus) return;

    const row = event.target.closest('[data-cart-line]');
    const control = event.target.closest('[data-qty-control]');
    if (!row || !control) return;

    const input = control.querySelector('.db-qty-input');
    if (!input) return;

    let quantity = parseInt(input.value || '0', 10);

    if (plus) quantity += 1;
    if (minus) quantity = Math.max(0, quantity - 1);

    input.value = quantity;
    row.classList.add('is-loading');

    try {
      const response = await fetch(root + 'cart/change.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json'
        },
        body: JSON.stringify({
          line: Number(row.dataset.cartLine),
          quantity: quantity
        })
      });

      if (!response.ok) throw new Error('Cart update failed');

      const cart = await response.json();

      if (quantity === 0) {
        row.remove();
      }

      if (cart.item_count >= 2) {
  let discountCode = 'DB2ZAKKEN';

  if (cart.item_count >= 4) {
    discountCode = 'DB4ZAKKEN';
  } else if (cart.item_count >= 3) {
    discountCode = 'DB3ZAKKEN';
  }

  sessionStorage.setItem('db_pending_discount', discountCode);
document.dispatchEvent(new CustomEvent('db:open-cart-drawer'));
  return;
}

      document.querySelectorAll('[data-cart-line]').forEach(function (cartRow, index) {
        cartRow.dataset.cartLine = index + 1;

        const priceEl = cartRow.querySelector('[data-line-price]');
        if (priceEl && cart.items[index]) {
          priceEl.textContent = formatDailyBearMoney(cart.items[index].final_line_price);
        }
      });

      const totalEl = document.querySelector('[data-cart-total]');
      if (totalEl) {
        totalEl.textContent = formatDailyBearMoney(cart.total_price);
      }

      updateCartDiscount(cart);

      const cartCount = document.querySelector('.cart-count');
      if (cartCount) {
        cartCount.textContent = cart.item_count;
      }

      if (cart.item_count === 0) {
        window.location.reload();
      }
    } catch (error) {
      console.error(error);
      window.location.reload();
    } finally {
      row.classList.remove('is-loading');
    }
  });
})();
/* Popup sluiten na inschrijven */
document.addEventListener('DOMContentLoaded', function () {
  const popup = document.querySelector('[data-launch-popup]');
  if (!popup) return;

  const popupForm = popup.querySelector('form');
  if (!popupForm) return;

  popupForm.addEventListener('submit', function () {
    const emailInput = popupForm.querySelector('input[type="email"]');

    if (emailInput && !emailInput.checkValidity()) {
      return;
    }

    sessionStorage.setItem('dailyBearLaunchPopupClosed', '1');

    setTimeout(function () {
      popup.hidden = true;
      document.body.classList.remove('no-scroll');
    }, 250);
  });
});
/* ===== Daily Bear pre-launch mode ===== */
document.addEventListener('DOMContentLoaded', function () {
  const storeOpen = document.body.dataset.storeOpen === 'true';
  const badge = document.querySelector('[data-db-launch-badge]');
  const launchLabel = document.body.dataset.launchLabel || 'Soon';
  const tr = function (key, fallback) {
    return window.DailyBearI18n ? window.DailyBearI18n.t(key) : fallback;
  };

  if (storeOpen) {
    if (badge) badge.hidden = true;
    return;
  }

  if (badge) badge.hidden = false;

  document.querySelectorAll('button[name="add"], .mobile-sticky-atc button, [data-db-cart-checkout]').forEach(function (button) {
    button.disabled = true;
    if (button.matches('button[name="add"], .mobile-sticky-atc button')) button.textContent = launchLabel;
    button.classList.add('db-prelaunch-disabled');
  });

  document.querySelectorAll('[data-bundle-qty]').forEach(function (button) {
    button.disabled = true;
  });

  document.querySelectorAll('.collection-card, .db-flavour-card').forEach(function (card) {
    if (card.querySelector('.db-prelaunch-card-label, .db-flavour-badge')) return;
    const label = document.createElement('div');
    label.className = 'db-prelaunch-card-label';
    label.textContent = tr('card_badge', 'Soon');
    card.appendChild(label);
  });
});
/* ===== Daily Bear: variant dropdown koppelen aan productfoto ===== */
document.addEventListener('DOMContentLoaded', function () {
  const gallery = document.querySelector('[data-gallery]');
  const variantSelect = document.querySelector('#VariantSelect');

  if (!gallery || !variantSelect) return;

  const mainImage = gallery.querySelector('[data-gallery-main]');
  const thumbs = Array.from(gallery.querySelectorAll('[data-gallery-thumb]'));

  function normalize(text) {
    return String(text || '')
      .toLowerCase()
      .replace('blueberry', 'bosbes')
      .replace('strawberry', 'aardbei')
      .replace('raspberry', 'framboos')
      .replace('watermelon', 'watermeloen')
      .replace('green apple', 'apple green')
      .replace('groene appel', 'apple green')
      .replace('appel groen', 'apple green')
      .replace(/\s+/g, ' ')
      .trim();
  }

  function setMainImage(thumb) {
    const src = thumb.getAttribute('data-src');
    const alt = thumb.getAttribute('data-alt') || '';

    if (mainImage && src) {
      mainImage.src = src;
      mainImage.alt = alt;
    }

    thumbs.forEach(function(item){
      item.classList.remove('is-active');
    });

    thumb.classList.add('is-active');
  }

  function setVariantByFlavor(flavor) {
    const cleanFlavor = normalize(flavor);
    const options = Array.from(variantSelect.options);

    const option = options.find(function(opt){
      return normalize(opt.textContent).includes(cleanFlavor);
    });

    if (!option) return;

    variantSelect.value = option.value;
    variantSelect.dispatchEvent(new Event('change', { bubbles:true }));
  }

  function setImageByVariant() {
    const selectedOption = variantSelect.options[variantSelect.selectedIndex];
    if (!selectedOption) return;

    const selectedText = normalize(selectedOption.textContent);

    const matchingThumb = thumbs.find(function(thumb){
      const flavor = normalize(thumb.getAttribute('data-flavor'));
      return flavor && selectedText.includes(flavor);
    });

    if (matchingThumb) {
      setMainImage(matchingThumb);
    }
  }

  thumbs.forEach(function(thumb){
    thumb.addEventListener('click', function(){
      setMainImage(thumb);
      setVariantByFlavor(thumb.getAttribute('data-flavor'));
    });
  });

  variantSelect.addEventListener('change', setImageByVariant);

  const urlFlavor = new URLSearchParams(window.location.search).get('smaak');
  if (urlFlavor) {
    setVariantByFlavor(urlFlavor);
    setImageByVariant();
  }
});
/* ===== Daily Bear cart drawer FINAL ===== */
document.addEventListener('DOMContentLoaded', function () {
  const drawer = document.querySelector('[data-db-cart-drawer]');
  if (!drawer) return;

  const itemsEl = drawer.querySelector('[data-db-cart-items]');
  const countEls = document.querySelectorAll('.cart-count, [data-db-cart-count]');
  const totalEls = drawer.querySelectorAll('[data-db-cart-total], [data-db-cart-total-button]');
  const shippingText = drawer.querySelector('[data-db-shipping-text]');
  const shippingBar = drawer.querySelector('[data-db-shipping-bar]');
  const discountRow = drawer.querySelector('[data-db-cart-discount-row]');
  const discountEl = drawer.querySelector('[data-db-cart-discount]');
  const checkoutBtn = drawer.querySelector('[data-db-cart-checkout]');
  const timerEl = drawer.querySelector('[data-db-cart-timer]');

  const FREE_SHIPPING_CENTS = 5000;
  const CART_TIMER_SECONDS = 600;
  const TIMER_KEY = 'dailybear_cart_timer_end';

  function money(cents) {
    return new Intl.NumberFormat((document.documentElement.lang || 'nl').toLowerCase().startsWith('en') ? 'en-BE' : 'nl-BE', {
      style: 'currency',
      currency: 'EUR'
    }).format((cents || 0) / 100);
  }

  function pad(n) {
    return String(n).padStart(2, '0');
  }

  function formatDate(date) {
    return date.toLocaleDateString((document.documentElement.lang || 'nl').toLowerCase().startsWith('en') ? 'en-BE' : 'nl-BE', {
      day: 'numeric',
      month: 'long',
      year: 'numeric'
    });
  }

  function addBusinessDays(days) {
    const date = new Date();
    let added = 0;

    while (added < days) {
      date.setDate(date.getDate() + 1);

      const day = date.getDay();
      if (day !== 0 && day !== 6) {
        added++;
      }
    }

    return date;
  }

  const deliveryDateText = formatDate(addBusinessDays(2));

  function installProductDeliveryMessage() {
    const productInfo = document.querySelector('.product-info');
    if (!productInfo || document.querySelector('.db-product-delivery')) return;

    const target = productInfo.querySelector('.product-short') || productInfo.querySelector('.product-main-price');

    if (!target) return;

    target.insertAdjacentHTML('afterend', `
      <div class="db-product-delivery">
        <span></span>
        <p>Verwachte bezorgdag: <strong>${deliveryDateText}</strong></p>
      </div>
    `);
  }

  installProductDeliveryMessage();

  function openDrawer() {
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    document.body.classList.add('no-scroll');
  }

  function closeDrawer() {
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('no-scroll');
  }

  async function getCart() {
    const res = await fetch('/cart.js', {
      headers: { Accept: 'application/json' }
    });

    return await res.json();
  }

  function startTimer(reset) {
    const now = Date.now();
    const currentEnd = Number(localStorage.getItem(TIMER_KEY) || 0);

    if (reset || !currentEnd || currentEnd <= now) {
      localStorage.setItem(TIMER_KEY, String(now + CART_TIMER_SECONDS * 1000));
    }
  }

  function stopTimer() {
    localStorage.removeItem(TIMER_KEY);
    if (timerEl) timerEl.textContent = '00:00';
  }

  async function clearCartByTimer() {
    stopTimer();

    await fetch('/cart/clear.js', {
      method: 'POST',
      headers: { Accept: 'application/json' }
    });

    const cart = await getCart();
    renderCart(cart);
  }

  function updateTimer() {
    if (!timerEl) return;

    const end = Number(localStorage.getItem(TIMER_KEY) || 0);

    if (!end) {
      timerEl.textContent = '10:00';
      return;
    }

    const remaining = end - Date.now();

    if (remaining <= 0) {
      timerEl.textContent = '00:00';
      clearCartByTimer();
      return;
    }

    const minutes = Math.floor(remaining / 60000);
    const seconds = Math.floor((remaining % 60000) / 1000);

    timerEl.textContent = pad(minutes) + ':' + pad(seconds);
  }

  setInterval(updateTimer, 1000);
  updateTimer();

  function updateShipping(cart) {
    const total = cart.total_price || 0;
    const progress = Math.min(100, Math.round((total / FREE_SHIPPING_CENTS) * 100));
    const remaining = Math.max(0, FREE_SHIPPING_CENTS - total);

    if (shippingBar) shippingBar.style.width = progress + '%';

    if (!shippingText) return;

    if (remaining <= 0 && cart.item_count > 0) {
      shippingText.textContent = 'Gratis verzending unlocked!';
    } else {
      shippingText.textContent = 'Nog ' + money(remaining) + ' tot gratis verzending';
    }
  }

  function renderCart(cart) {
    countEls.forEach(function (el) {
      el.textContent = cart.item_count;
    });

    totalEls.forEach(function (el) {
      el.textContent = money(cart.total_price);
    });

    updateShipping(cart);

    if (cart.item_count > 0) {
      startTimer(false);
    } else {
      stopTimer();
    }

    if (cart.total_discount > 0) {
      if (discountRow) discountRow.hidden = false;
      if (discountEl) discountEl.textContent = '-' + money(cart.total_discount);
    } else {
      if (discountRow) discountRow.hidden = true;
    }

    if (!itemsEl) return;

    if (!cart.items.length) {
      itemsEl.innerHTML = '<div class="db-cart-drawer__empty">Je winkelmand is nog leeg.</div>';
      return;
    }

    itemsEl.innerHTML = cart.items.map(function (item, index) {
      const original = item.original_line_price || item.line_price;
      const finalPrice = item.final_line_price || item.line_price;
      const saving = Math.max(0, original - finalPrice);

      return `
        <div class="db-cart-item" data-db-drawer-line="${index + 1}">
          <img src="${item.image || ''}" alt="${item.product_title || ''}">

          <div>
            <h3>${item.product_title || ''}</h3>
            <p>${item.variant_title && item.variant_title !== 'Default Title' ? item.variant_title : ''}</p>

            <div class="db-cart-item__delivery">
              <span></span>
              Verwachte bezorgdag: <strong>${deliveryDateText}</strong>
            </div>

            <div class="db-cart-item__qty">
              <button type="button" data-db-drawer-minus>−</button>
              <span>${item.quantity}</span>
              <button type="button" data-db-drawer-plus>+</button>
            </div>
          </div>

          <div class="db-cart-item__price">
            ${saving > 0 ? `<s>${money(original)}</s>` : ''}
            <strong>${money(finalPrice)}</strong>
            ${saving > 0 ? `<small class="db-cart-item__save">Je bespaart ${money(saving)}</small>` : ''}
            <button type="button" class="db-cart-item__remove" data-db-drawer-remove aria-label="Verwijderen">🗑</button>
          </div>
        </div>
      `;
    }).join('');
  }

  async function refreshCart(open) {
    const cart = await getCart();
    renderCart(cart);
    if (open) openDrawer();
  }

  async function changeLine(line, quantity) {
    const res = await fetch('/cart/change.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },
      body: JSON.stringify({ line: line, quantity: quantity })
    });

    const cart = await res.json();
    renderCart(cart);
  }

  drawer.querySelectorAll('[data-db-cart-close]').forEach(function (btn) {
    btn.addEventListener('click', closeDrawer);
  });

  document.addEventListener('keyup', function (event) {
    if (event.key === 'Escape') closeDrawer();
  });

  document.addEventListener('click', function (event) {
    const cartLink = event.target.closest('a[href="/cart"], a[href*="/cart"]');

    if (cartLink && !cartLink.closest('.db-cart-drawer')) {
      event.preventDefault();
      refreshCart(true);
    }

    const row = event.target.closest('[data-db-drawer-line]');
    if (!row) return;

    const line = Number(row.getAttribute('data-db-drawer-line'));
    const qtyText = row.querySelector('.db-cart-item__qty span');
    const currentQty = Number(qtyText ? qtyText.textContent : 1);

    if (event.target.closest('[data-db-drawer-plus]')) {
      changeLine(line, currentQty + 1);
    }

    if (event.target.closest('[data-db-drawer-minus]')) {
      changeLine(line, Math.max(0, currentQty - 1));
    }

    if (event.target.closest('[data-db-drawer-remove]')) {
      changeLine(line, 0);
    }
  });

  document.querySelectorAll('form[action*="/cart/add"]').forEach(function (form) {
    if (form.dataset.dbDrawerReady === 'true') return;
    form.dataset.dbDrawerReady = 'true';

    form.addEventListener('submit', async function (event) {
      event.preventDefault();

      try {
        const res = await fetch('/cart/add.js', {
          method: 'POST',
          body: new FormData(form),
          headers: { Accept: 'application/json' }
        });

        if (!res.ok) throw new Error('Add failed');

        startTimer(true);
        await refreshCart(true);
      } catch (error) {
        console.error(error);
        alert('Kon product niet toevoegen. Check voorraad of variant.');
      }
    });
  });

  if (checkoutBtn) {
    checkoutBtn.addEventListener('click', function () {
      getCart().then(function (cart) {
        if (!cart.items.length) {
          alert('Je winkelmand is nog leeg.');
          return;
        }

        window.location.href = '/checkout';
      });
    });
  }

  refreshCart(false);
});
/* ===== Daily Bear cart timer override: start alleen bij product ===== */
document.addEventListener('DOMContentLoaded', function () {
  const drawer = document.querySelector('[data-db-cart-drawer]');
  if (!drawer) return;

  const timerRow = drawer.querySelector('.db-cart-drawer__timer');
  const timerEl = drawer.querySelector('[data-db-cart-timer]');
  const itemsEl = drawer.querySelector('[data-db-cart-items]');
  const shippingText = drawer.querySelector('[data-db-shipping-text]');
  const shippingBar = drawer.querySelector('[data-db-shipping-bar]');
  const totalEls = drawer.querySelectorAll('[data-db-cart-total], [data-db-cart-total-button]');
  const countEls = document.querySelectorAll('.cart-count, [data-db-cart-count]');

  if (!timerRow || !timerEl) return;

  const TIMER_KEY = 'dailybear_cart_timer_end_final';
  const TIMER_SECONDS = 600; // 10 minuten 0 seconden

  let isClearing = false;

  function pad(number) {
    return String(number).padStart(2, '0');
  }

  function money(cents) {
    return new Intl.NumberFormat((document.documentElement.lang || 'nl').toLowerCase().startsWith('en') ? 'en-BE' : 'nl-BE', {
      style: 'currency',
      currency: 'EUR'
    }).format((cents || 0) / 100);
  }

  function getCartCountFromPage() {
    const countEl = drawer.querySelector('[data-db-cart-count]') || document.querySelector('.cart-count');
    const count = parseInt(countEl ? countEl.textContent : '0', 10);
    return Number.isNaN(count) ? 0 : count;
  }

  function hideTimer() {
    timerRow.classList.remove('is-active');
    timerEl.textContent = '10:00';
    localStorage.removeItem(TIMER_KEY);
  }

  function showTimer() {
    timerRow.classList.add('is-active');
  }

  function setEmptyCartUI() {
    countEls.forEach(function (el) {
      el.textContent = '0';
    });

    totalEls.forEach(function (el) {
      el.textContent = money(0);
    });

    if (shippingText) {
      shippingText.textContent = 'Nog €50,00 tot gratis verzending';
    }

    if (shippingBar) {
      shippingBar.style.width = '0%';
    }

    if (itemsEl) {
      itemsEl.innerHTML = '<div class="db-cart-drawer__empty">Je winkelmand is nog leeg.</div>';
    }

    hideTimer();
  }

  async function clearCart() {
    if (isClearing) return;
    isClearing = true;

    try {
      await fetch('/cart/clear.js', {
        method: 'POST',
        headers: {
          Accept: 'application/json'
        }
      });

      setEmptyCartUI();
    } catch (error) {
      console.error('Cart clear failed:', error);
    }

    isClearing = false;
  }

  function tickTimer() {
    const count = getCartCountFromPage();

    if (count <= 0) {
      hideTimer();
      return;
    }

    showTimer();

    let endTime = Number(localStorage.getItem(TIMER_KEY) || 0);

    if (!endTime) {
      endTime = Date.now() + TIMER_SECONDS * 1000;
      localStorage.setItem(TIMER_KEY, String(endTime));
    }

    const remaining = endTime - Date.now();

    if (remaining <= 0) {
      timerEl.textContent = '00:00';
      clearCart();
      return;
    }

    const minutes = Math.floor(remaining / 60000);
    const seconds = Math.floor((remaining % 60000) / 1000);

    timerEl.textContent = pad(minutes) + ':' + pad(seconds);
  }

  // Start meteen correct
  tickTimer();

  // Blijf aftellen
  setInterval(tickTimer, 1000);

  // Na toevoegen/verwijderen/plus/min opnieuw checken
  document.addEventListener('click', function () {
    setTimeout(tickTimer, 500);
    setTimeout(tickTimer, 1200);
  }, true);

  document.addEventListener('submit', function () {
    setTimeout(tickTimer, 800);
    setTimeout(tickTimer, 1500);
  }, true);
});
/* ===== Product delivery badge verplaatsen boven betaalmethodes ===== */
document.addEventListener('DOMContentLoaded', function () {
  function moveDeliveryBadge() {
    const deliveryBadge = document.querySelector('.db-product-delivery');
    const paymentBlock = document.querySelector('.product-info .db-payment-block');
    const paymentTitle = document.querySelector('.product-info .db-payment-title');

    if (paymentTitle) {
      paymentTitle.textContent = 'Betaal veilig met:';
    }

    if (deliveryBadge && paymentBlock) {
      paymentBlock.parentNode.insertBefore(deliveryBadge, paymentBlock);
    }
  }

  moveDeliveryBadge();
  setTimeout(moveDeliveryBadge, 500);
  setTimeout(moveDeliveryBadge, 1500);
});
/* ===== Daily Bear cart drawer discount code STACKING ===== */
document.addEventListener('DOMContentLoaded', function () {
  const discountForm = document.querySelector('[data-db-discount-form]');
  const discountInput = document.querySelector('[data-db-discount-input]');
  const discountMessage = document.querySelector('[data-db-discount-message]');
  const discountRow = document.querySelector('[data-db-cart-discount-row]');
  const discountEl = document.querySelector('[data-db-cart-discount]');
  const totalEls = document.querySelectorAll('[data-db-cart-total], [data-db-cart-total-button]');
  const countEls = document.querySelectorAll('.cart-count, [data-db-cart-count]');

  if (!discountForm || !discountInput) return;

  const BUNDLE_CODES = ['DB2ZAKKEN', 'DB3ZAKKEN', 'DB4ZAKKEN'];

  function money(cents) {
    return new Intl.NumberFormat((document.documentElement.lang || 'nl').toLowerCase().startsWith('en') ? 'en-BE' : 'nl-BE', {
      style: 'currency',
      currency: 'EUR'
    }).format((cents || 0) / 100);
  }

  function setMessage(text, type) {
    if (!discountMessage) return;

    discountMessage.textContent = text || '';
    discountMessage.classList.remove('is-success', 'is-error');

    if (type) {
      discountMessage.classList.add(type);
    }
  }

  function normalizeCode(code) {
    return String(code || '').trim().toUpperCase();
  }

  function getBundleCodeFromCart(cart) {
    const count = cart.item_count || 0;

    if (count >= 4) return 'DB4ZAKKEN';
    if (count >= 3) return 'DB3ZAKKEN';
    if (count >= 2) return 'DB2ZAKKEN';

    return '';
  }

  function getSavedCustomerCode() {
    return normalizeCode(sessionStorage.getItem('db_customer_discount_code') || '');
  }

  function setSavedCustomerCode(code) {
    code = normalizeCode(code);

    if (code) {
      sessionStorage.setItem('db_customer_discount_code', code);
    } else {
      sessionStorage.removeItem('db_customer_discount_code');
    }
  }

  function buildDiscountString(bundleCode, customerCode) {
    const codes = [];

    bundleCode = normalizeCode(bundleCode);
    customerCode = normalizeCode(customerCode);

    if (bundleCode) codes.push(bundleCode);

    if (customerCode && !BUNDLE_CODES.includes(customerCode) && customerCode !== bundleCode) {
      codes.push(customerCode);
    }

    return codes.join(',');
  }

  function updateCartTotals(cart) {
    countEls.forEach(function (el) {
      el.textContent = cart.item_count || 0;
    });

    totalEls.forEach(function (el) {
      el.textContent = money(cart.total_price || 0);
    });

    if (cart.total_discount && cart.total_discount > 0) {
      if (discountRow) discountRow.hidden = false;
      if (discountEl) discountEl.textContent = '-' + money(cart.total_discount);
    } else {
      if (discountRow) discountRow.hidden = true;
      if (discountEl) discountEl.textContent = '-€0,00';
    }
  }

  async function getCart() {
    const res = await fetch('/cart.js', {
      headers: { Accept: 'application/json' }
    });

    return await res.json();
  }

  async function applyDiscounts(discountString) {
    const res = await fetch('/cart/update.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },
      body: JSON.stringify({
        discount: discountString
      })
    });

    if (!res.ok) {
      throw new Error('Discount update failed');
    }

    return await getCart();
  }

  async function reapplyBundleAndCustomerCode(message) {
    const cartBefore = await getCart();

    const bundleCode = getBundleCodeFromCart(cartBefore);
    const customerCode = getSavedCustomerCode();
    const discountString = buildDiscountString(bundleCode, customerCode);

    const cartAfter = await applyDiscounts(discountString);

    updateCartTotals(cartAfter);

    if (discountInput && customerCode) {
      discountInput.value = customerCode;
    }

    if (message) {
      setMessage(message, 'is-success');
    } else if (bundleCode && customerCode) {
      setMessage('Bundelkorting + kortingscode toegepast.', 'is-success');
    } else if (bundleCode) {
      setMessage('Bundelkorting toegepast.', 'is-success');
    }

    return cartAfter;
  }

  discountForm.addEventListener('submit', async function (event) {
    event.preventDefault();

    const customerCode = normalizeCode(discountInput.value);

    if (!customerCode) {
      setMessage('Vul eerst een kortingscode in.', 'is-error');
      return;
    }

    setSavedCustomerCode(customerCode);
    setMessage('Kortingscode toepassen...', '');

    try {
      const cart = await reapplyBundleAndCustomerCode();

      if (cart.total_discount && cart.total_discount > 0) {
        setMessage('Bundelkorting + jouw kortingscode toegepast.', 'is-success');
      } else {
        setMessage('Code toegevoegd. De korting verschijnt als de voorwaarden kloppen.', 'is-success');
      }
    } catch (error) {
      console.error(error);
      setMessage('Deze kortingscode kon niet worden toegepast.', 'is-error');
    }
  });

  document.addEventListener('db:cart-updated', function () {
    reapplyBundleAndCustomerCode().catch(function (error) {
      console.error(error);
    });
  });

  setTimeout(function () {
    reapplyBundleAndCustomerCode().catch(function () {});
  }, 800);
});
/* ===== Apply pending bundle discount in cart drawer ===== */
document.addEventListener('DOMContentLoaded', function () {
  async function applyPendingDiscount() {
    const code = sessionStorage.getItem('db_pending_discount');

    if (!code) return;

    sessionStorage.removeItem('db_pending_discount');

    try {
      await fetch('/cart/update.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json'
        },
        body: JSON.stringify({
          discount: code
        })
      });

      const discountInput = document.querySelector('[data-db-discount-input]');
      const discountMessage = document.querySelector('[data-db-discount-message]');

      if (discountInput) {
        discountInput.value = code;
      }

      if (discountMessage) {
        discountMessage.textContent = 'Bundelkorting toegepast.';
        discountMessage.classList.add('is-success');
      }

      document.dispatchEvent(new CustomEvent('db:refresh-cart-drawer'));
    } catch (error) {
      console.error('Bundelkorting toepassen mislukt:', error);
    }
  }

  document.addEventListener('db:open-cart-drawer', function () {
    setTimeout(applyPendingDiscount, 400);
  });

  setTimeout(applyPendingDiscount, 700);
});
/* ===== Daily Bear Creatine Check Tool ===== */
document.addEventListener('DOMContentLoaded', function () {
  const modal = document.querySelector('[data-creatine-check]');
  const openBtns = document.querySelectorAll('[data-creatine-check-open]');
  const closeBtns = document.querySelectorAll('[data-creatine-check-close]');
  const calcBtn = document.querySelector('[data-creatine-calculate]');
  const result = document.querySelector('[data-creatine-result]');

  if (!modal || !calcBtn || !result) return;

  const tr = function (key, fallback) {
    return window.DailyBearI18n ? window.DailyBearI18n.t(key) : fallback;
  };

  function openModal() {
    modal.hidden = false;
    document.body.classList.add('no-scroll');
  }

  function closeModal() {
    modal.hidden = true;
    document.body.classList.remove('no-scroll');
  }

  openBtns.forEach(function (btn) { btn.addEventListener('click', openModal); });
  closeBtns.forEach(function (btn) { btn.addEventListener('click', closeModal); });

  calcBtn.addEventListener('click', function () {
    const age = Number(document.querySelector('[data-creatine-age]').value || 0);
    const weight = Number(document.querySelector('[data-creatine-weight]').value || 0);
    const training = Number(document.querySelector('[data-creatine-training]').value || 0);
    const current = Number(document.querySelector('[data-creatine-current]').value || 0);

    if (!age || !weight) {
      result.hidden = false;
      result.innerHTML = '<h3>' + tr('enter_details_title', 'Vul je gegevens in') + '</h3><p>' + tr('enter_details_text', 'Vul je leeftijd en gewicht in om je persoonlijke routine te bekijken.') + '</p>';
      return;
    }

    if (age < 18) {
      result.hidden = false;
      result.innerHTML = '<h3>' + tr('minor_title', 'Geen persoonlijke suppletierichtlijn') + '</h3><p>' + tr('minor_text_1', 'Voor personen onder 18 jaar geeft deze tool geen persoonlijke creatinerichtlijn.') + '</p><p>' + tr('minor_text_2', 'Bespreek supplementgebruik eerst met een ouder, arts of gekwalificeerde professional.') + '</p>';
      return;
    }

    let titleKey = 'routine_everyday_title';
    let contextKey = 'routine_no_sport';
    if (training === 1) {
      titleKey = 'routine_light_title';
      contextKey = 'routine_light';
    } else if (training >= 2 && training < 4) {
      titleKey = 'routine_active_title';
      contextKey = 'routine_active';
    } else if (training >= 4) {
      titleKey = 'routine_high_title';
      contextKey = 'routine_high';
    }

    let routine = '<h3>' + tr(titleKey, 'Jouw creatine-routine') + '</h3>' +
      '<p>' + tr('routine_base', 'Een algemene dagelijkse richtlijn voor gezonde volwassenen is 3–5 g creatine monohydraat per dag. Volg altijd het etiket.') + '</p>' +
      '<p>' + tr('routine_serving', 'Met Daily Bear levert 1 serving per dag 5 g creatine.') + '</p>' +
      '<p>' + tr(contextKey, '') + '</p>' +
      '<p>' + tr('routine_days', 'Een zak met 150 gummies komt bij 5 gummies per dag overeen met ongeveer 30 dagen routine.') + '</p>';

    if (weight < 55) routine += '<p>' + tr('routine_weight_light', '') + '</p>';
    if (weight > 100) routine += '<p>' + tr('routine_weight_high', '') + '</p>';
    if (current === 1) routine += '<p><strong>' + tr('routine_current', '') + '</strong></p>';

    routine += '<p>' + tr('routine_consistency', '') + '</p><small>' + tr('general_disclaimer', '') + '</small>';
    result.hidden = false;
    result.innerHTML = routine;
  });
});

